import { ManagementState } from '../index'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'

function isEditing(state: ManagementState, entityId: EntityIdType) {
  return state.editingEntityId === entityId
}

function getCustomLoginMode(state: ManagementState) {
  return state.customLoginMode
}

function isUserFreemium(state: ManagementState) {
  return state.user.isFreemium
}

function getEditingId(state: ManagementState) {
  return state.editingEntityId
}

function getActivePopupId(state: ManagementState) {
  return state.activePopupId
}

function isSideMenuOpened(state: ManagementState) {
  return state.sideMenuOpened
}

function isDropDownMenuOpened(state: ManagementState) {
  return state.dropDownMenuOpened
}

function isInstantUploadEnabled(state: ManagementState) {
  return state.instantUploadEnabled
}

function isCodeDialogOpened(state: ManagementState) {
  return state.isCodeDialogOpened
}

function isCodeDialogPortalAllowed(state: ManagementState) {
  return state.isCodeDialogPortalAllowed
}

export function isUserAdmin(state: ManagementState) {
  return state.user.isAdmin
}

function getUserName(state: ManagementState) {
  return state.user.name
}

export function getUserId(state: ManagementState) {
  return state.user.id
}

function getUserTimezone(state: ManagementState) {
  return state.user.timezone
}

export function getUserLocale(state: ManagementState) {
  return state.user.dashboardLocale
}

export function getImpersonatorId(state: ManagementState) {
  return state.user.impersonator?.id
}

function hasFacebookConversionPixel(state: ManagementState) {
  return state.hasFacebookConversionPixel
}

const managementSelectors = {
  isEditing,
  isUserFreemium,
  getEditingId,
  isUserAdmin,
  getCustomLoginMode,
  getActivePopupId,
  isSideMenuOpened,
  isDropDownMenuOpened,
  isInstantUploadEnabled,
  isCodeDialogOpened,
  isCodeDialogPortalAllowed,
  getUserName,
  getUserTimezone,
  hasFacebookConversionPixel,
  getUserId,
  getUserLocale,
}

export default managementSelectors
